import {FC} from 'react';

import {Skeleton} from '@mui/material';

import {
  PromoTagContainer,
  PromoTagCount,
  PromoTagImage,
  PromoTagText,
  PromoTagWrapper,
  StyledBadgeContainer,
  StyledBadgeCountWrapper,
  StyledBadgeTextWrapper,
  StyledBadgeWrapper,
  StyledIconWrapper,
  StyledImage,
  StyledImageWrapper,
  StyledWrapper
} from './styles';
import {ProductLoyalityPromoViewProps} from './types';

const ProductLoyalityPromoView: FC<ProductLoyalityPromoViewProps> = ({
  hasImageUrl,
  icon,
  count,
  label,
  loading,
  titleTextColor,
  bgColor,
  isShowLoyaltyCampaignPromoV2,
  iconUrl
}) => {
  if (loading) {
    return (
      <Skeleton height={36} width="100%" variant="rounded">
        <StyledWrapper />
      </Skeleton>
    );
  } else if (hasImageUrl) {
    return (
      <StyledWrapper>
        <StyledImageWrapper>
          <StyledImage
            {...{
              loading: 'lazy',
              src: hasImageUrl
            }}
          />
        </StyledImageWrapper>
      </StyledWrapper>
    );
  } else {
    if (!label) {
      return <StyledWrapper />;
    }

    if (isShowLoyaltyCampaignPromoV2) {
      return (
        <PromoTagWrapper>
          <PromoTagContainer>
            <PromoTagImage src={iconUrl} alt="promo" />
            <PromoTagText component="span">{label}</PromoTagText>
          </PromoTagContainer>
          {count && count > 1 ? <PromoTagCount component="span"> {`+${count - 1}`}</PromoTagCount> : null}
        </PromoTagWrapper>
      );
    }

    return (
      <StyledWrapper>
        <StyledBadgeContainer>
          {(icon || label) && (
            <StyledBadgeWrapper sx={{backgroundColor: bgColor, color: titleTextColor, width: '100%'}}>
              <StyledIconWrapper>{icon}</StyledIconWrapper>
              <StyledBadgeTextWrapper component="span">{label}</StyledBadgeTextWrapper>
            </StyledBadgeWrapper>
          )}
          {count && count > 1 ? (
            <StyledBadgeCountWrapper component="span"> {`+${count - 1}`}</StyledBadgeCountWrapper>
          ) : null}
        </StyledBadgeContainer>
      </StyledWrapper>
    );
  }
};

ProductLoyalityPromoView.displayName = 'MakroUI.ProductLoyalityPromoView';

export default ProductLoyalityPromoView;
